/**
 * Announcement Bar Section
 * Top banner for promotions and notices
 */

import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './sections.css';

function AnnouncementBar({ settings = {}, content = {}, globalStyles = {}, store }) {
  const {
    backgroundColor = '#1a1a2e',
    textColor = '#ffffff',
    linkColor = '#60a5fa',
    closeColor = '#9ca3af',
    fontSize = 'small',
    padding = 'medium',
    dismissible = true,
  } = settings;

  const {
    text = '',
    link = '',
    linkText = '',
  } = content;

  const [isDismissed, setIsDismissed] = useState(false);

  // Check if previously dismissed (session storage)
  useEffect(() => {
    const dismissedKey = `ts-announcement-${store?.id || 'default'}`;
    const wasDismissed = sessionStorage.getItem(dismissedKey);
    if (wasDismissed) {
      setIsDismissed(true);
    }
  }, [store?.id]);

  const handleDismiss = () => {
    setIsDismissed(true);
    const dismissedKey = `ts-announcement-${store?.id || 'default'}`;
    sessionStorage.setItem(dismissedKey, 'true');
  };

  // Don't render if no text or dismissed
  if (!text || isDismissed) {
    return null;
  }

  const fontSizeMap = {
    small: '13px',
    medium: '14px',
    large: '16px',
  };

  const paddingMap = {
    small: '8px 0',
    medium: '12px 0',
    large: '16px 0',
  };

  const barStyle = {
    backgroundColor,
    color: textColor,
    padding: paddingMap[padding] || paddingMap.medium,
    fontSize: fontSizeMap[fontSize] || fontSizeMap.small,
  };

  const linkStyle = {
    color: linkColor,
  };

  const closeStyle = {
    color: closeColor,
  };

  return (
    <div className="ts-announcement-bar" style={barStyle}>
      <div className="ts-announcement-bar__container">
        <p className="ts-announcement-bar__text">
          {text}
          {link && linkText && (
            <>
              {' '}
              <Link to={link} className="ts-announcement-bar__link" style={linkStyle}>
                {linkText}
              </Link>
            </>
          )}
        </p>

        {dismissible && (
          <button
            className="ts-announcement-bar__dismiss"
            onClick={handleDismiss}
            aria-label="Dismiss announcement"
            style={closeStyle}
          >
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

export default React.memo(AnnouncementBar);
